export default {
  partner: {
    header: {
      title: 'Mehr als eine Buchungsplattform',
      description:
        'Verwalte Dein Unternehmen mit einer All-in-One-Software und steigere Deinen Umsatz.',
      buttonLabel: 'Jetzt loslegen',
    },
    registration: {
      form: {
        steps: {
          general: 'Allgemein',
          business: 'Angebot',
          register: 'Registrierung',
        },
        footer: {
          helpText:
            'Brauchst Du Hilfe? Kontaktiere unser Partner-Support-Team unter',
        },
        step1: {
          title: 'Registriere Dich in 2 Minuten',
          section: {
            generalInformation: 'Allgemeine Informationen',
          },
          businessName: 'Firmenname',
          businessAddress: 'Geschäftsadresse',
          phoneNumber: 'Telefonnummer',
          websiteInstagram: 'Webseite/Instagram',
          businessSize: 'Unternehmensgröße (Anzahl der Mitarbeiter)',
          businessSizeOptions: {
            '0-5': '0 - 5',
            '5-25': '5 - 25',
            '25-50': '25 - 50',
            '50-100': '50 - 100',
            '100-500': '100 - 500',
            '500-1000': '500 - 1000',
            '1000+': '1000+',
          },
          annualRevenueRange: 'Jahresumsatz in EUR',
          referral: 'Empfehlung',
          language: 'Profil-Sprache',
          next: 'Weiter',
          selectOption: 'Option auswählen',
          revenue: {
            '0-10000': '0€ - 10.000€',
            '10000-25000': '10.000€ - 25.000€',
            '25000-50000': '25.000€ - 50.000€',
            '50000-100000': '50.000€ - 100.000€',
            '100000-250000': '100.000€ - 250.000€',
            '250000-500000': '250.000€ - 500.000€',
            '500000-1000000': '500.000€ - 1.000.000€',
            '1000000+': '+1.000.000€',
          },
          languageOptions: {
            de: 'Deutsch',
            en: 'Englisch',
          },
          benefits: {
            title: 'Warum Partner mit konfetti werden?',
            reachCustomers: 'Erreiche Tausende von Kunden',
            easyManagement: 'Einfaches Buchungsmanagement',
            marketingSupport: 'Marketing-Unterstützung',
          },
        },
        step2: {
          title: 'Beschreibe was Du anbieten möchtest',
          experienceTypes: {
            question: 'Welche Art von Erlebnissen bietest Du an?',
            experiences: {
              label: 'Erlebnisse',
              description: 'z.B. Escape Room, Tastings',
            },
            tours: {
              label: 'Touren',
              description: 'z.B. Stadtführungen, Bootstouren',
            },
            classes: {
              label: 'Kurse',
              description: 'z.B. Töpfern, Kochkurs, Cocktailkurs',
            },
            diyKits: {
              label: 'DIY-Kits',
              description: 'Du versendest DIY-Kits',
            },
          },
          groupExperiences: {
            question:
              'Bietest Du Erlebnisse ausschließlich für Gruppen an? (JGA, Teamevents, etc.)',
          },
          bookingSystem: {
            question: 'Wie buchen Kunden aktuell?',
            selectLabel: 'Wähle Dein Buchungssystem',
            other: 'Andere',
            options: {
              ownOnlineShop: 'Eigener Online-Shop',
              onlyViaEmail: 'Nur per E-Mail, Kontaktformular oder Telefon',
              bokun: 'Bokun',
              bookingkitLink: 'Bookingkit',
              eventbriteLink: 'Eventbrite',
              eventimLink: 'Eventim',
              fareHarbor: 'Fare Harbor',
              jsMydaysLink: 'mydays',
              luma: 'Luma',
              quandoo: 'Quandoo',
              shopify: 'Shopify',
              travelmanager: 'Travelmanager',
              woocommerce: 'woocommerce',
              regiondoLink: 'Regiondo',
              noWebsite: 'Keine Website',
            },
          },
          offerType: {
            label: 'Angebotstyp',
            placeholder:
              'Beschreibe hier Dein Angebot, welches Du auf gokonfetti.com listen willst.',
          },
          yes: 'Ja',
          no: 'Nein',
          selectOption: 'Option auswählen',
          submitButton: 'Zur Registrierung',
        },
        step3: {
          title: 'Registrierung',
          accountSetup: {
            title: 'Konto-Einrichtung',
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            password: 'Passwort',
          },
          terms: {
            title: 'AGB',
            text: 'Ich habe die {termsLink} gelesen und stimme diesen zu. Außerdem stimme ich zu, dass mich das Team von konfetti über meine zuvor angegebenen Kontaktdaten kontaktieren darf.*',
            linkText: 'Angebotsanbieter-AGB',
          },
          submitButton: 'Registrierung abschließen',
        },
      },
    },
  },
}
